// Generated by `npm run figma:build` from the Icons Library. Do not edit.
export const ICON_FILES = new Set([
    'align-left',
    'align-right',
    'armchair-filled',
    'armchair',
    'arrow-collapse',
    'arrow-down',
    'arrow-expand',
    'arrow-extend-horizontal',
    'arrow-left',
    'arrow-long-up-down',
    'arrow-long-up',
    'arrow-right',
    'arrow-turn-right',
    'arrow-up-circle-filled',
    'arrow-up-circle',
    'arrow-up-right',
    'arrow-up',
    'banknote-filled',
    'banknote',
    'bed-filled',
    'bed',
    'bold',
    'book-open-filled',
    'book-open',
    'bookmark-filled',
    'bookmark',
    'box-filled',
    'box',
    'briefcase-filled',
    'briefcase',
    'building-filled',
    'building',
    'calendar-filled',
    'calendar',
    'camera-circle-filled',
    'camera-circle',
    'camera-filled',
    'camera',
    'caret-down-filled',
    'caret-down',
    'caret-up-filled',
    'caret-up',
    'category-filled',
    'category',
    'certificate-filled',
    'certificate',
    'chat-filled',
    'chat-x-filled',
    'chat-x',
    'chat',
    'check-circle-filled',
    'check-circle',
    'check',
    'chevron-double-down',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-double-up',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'circle-dash',
    'circle-dot-dash',
    'circle-dot',
    'clear-formatting-filled',
    'clear-formatting',
    'clock-filled',
    'clock',
    'close',
    'code',
    'coffee-filled',
    'coffee',
    'comment-filled',
    'comment',
    'cookie-filled',
    'cookie',
    'copy-filled',
    'copy',
    'copyright-filled',
    'copyright',
    'coupon-filled',
    'coupon-tilted-filled',
    'coupon-tilted',
    'coupon',
    'credit-card-cvc',
    'credit-card-filled',
    'credit-card',
    'cursor-filled',
    'cursor',
    'desktop-filled',
    'desktop-question-filled',
    'desktop-question',
    'desktop',
    'diamond-filled',
    'diamond',
    'dollar',
    'dot',
    'download',
    'edit-check-filled',
    'edit-check',
    'edit-circle-filled',
    'edit-circle',
    'edit-filled',
    'edit',
    'email-filled',
    'email',
    'eye-filled',
    'eye-off-filled',
    'eye-off',
    'eye',
    'file-archive-filled',
    'file-archive',
    'file-download-filled',
    'file-download',
    'file-excel-filled',
    'file-excel',
    'file-filled',
    'file-image-filled',
    'file-image',
    'file-invoice-filled',
    'file-invoice',
    'file-lesson-filled',
    'file-lesson',
    'file-pdf-download-filled',
    'file-pdf-download',
    'file-pdf-filled',
    'file-pdf',
    'file-sheet-download-filled',
    'file-sheet-download',
    'file-text-filled',
    'file-text',
    'file',
    'filter',
    'flag-filled',
    'flag',
    'forbidden-filled',
    'forbidden',
    'forward-15',
    'fullscreen-exit',
    'fullscreen',
    'gift-filled',
    'gift',
    'git-branch-filled',
    'git-branch',
    'globe-filled',
    'globe',
    'graduation-cap-filled',
    'graduation-cap',
    'grid-filled',
    'grid',
    'hashtag-filled',
    'hashtag',
    'hd',
    'heart-filled',
    'heart',
    'help-filled',
    'help',
    'home-filled',
    'home',
    'image-filled',
    'image',
    'incognito-filled',
    'incognito',
    'infinity',
    'info-filled',
    'info',
    'italic',
    'laptop-filled',
    'laptop',
    'lightbulb-filled',
    'lightbulb',
    'lightning-filled',
    'lightning',
    'link',
    'list-bulleted',
    'list-numbered',
    'loading-track',
    'loading',
    'location-pin-filled',
    'location-pin-multiple-filled',
    'location-pin-multiple',
    'location-pin',
    'lock-filled',
    'lock',
    'logo-amazon-pay',
    'logo-amazon',
    'logo-apple-circle',
    'logo-apple',
    'logo-behance',
    'logo-dribbble',
    'logo-facebook-circle',
    'logo-google-circle',
    'logo-google',
    'logo-instagram-circle',
    'logo-ixdf-ai-tutor',
    'logo-ixdf-tree',
    'logo-linkedin-circle',
    'logo-medium',
    'logo-paypal',
    'logo-threads',
    'logo-tiktok',
    'logo-windows',
    'logo-x-circle',
    'logo-x',
    'logo-youtube-circle',
    'logout',
    'menu-compact',
    'menu',
    'minus',
    'mobile-filled',
    'mobile',
    'more-horizontal',
    'notification-filled',
    'notification',
    'number-0-filled',
    'number-0',
    'number-1-filled',
    'number-1',
    'number-2-filled',
    'number-2',
    'number-3-filled',
    'number-3',
    'number-4-filled',
    'number-4',
    'number-5-filled',
    'number-5',
    'number-6-filled',
    'number-6',
    'number-7-filled',
    'number-7',
    'number-8-filled',
    'number-8',
    'number-9-filled',
    'number-9',
    'paragraph-filled',
    'paragraph',
    'pause-filled',
    'pause',
    'picture-in-picture-filled',
    'picture-in-picture',
    'play-circle-filled',
    'play-circle',
    'play-filled',
    'play',
    'plus',
    'presentation-question-filled',
    'presentation-question',
    'quote-close-filled',
    'quote-close',
    'quote-open-filled',
    'quote-open',
    'quote-small-filled',
    'quote-small',
    'refresh',
    'rewind-15',
    'rss-filled',
    'rss',
    'search-filled',
    'search-history-filled',
    'search-history',
    'search',
    'server-filled',
    'server',
    'settings-filled',
    'settings',
    'share-filled',
    'share',
    'shield-check-filled',
    'shield-check',
    'sparkle-filled',
    'sparkle-focus-filled',
    'sparkle-focus',
    'sparkle',
    'star-25',
    'star-50',
    'star-75',
    'star-filled',
    'star',
    'table-filled',
    'table-of-contents-filled',
    'table-of-contents',
    'table',
    'tablet-filled',
    'tablet',
    'thumbs-up-filled',
    'thumbs-up',
    'trash-filled',
    'trash',
    'trend-down',
    'trend-up',
    'underline',
    'undo',
    'user-check-filled',
    'user-check',
    'user-filled',
    'user-plus-filled',
    'user-plus',
    'user',
    'users-filled',
    'users',
    'utensils-filled',
    'utensils',
    'video-call',
    'video-filled',
    'video-library-filled',
    'video-library',
    'video',
    'volume-high-filled',
    'volume-high',
    'volume-low-filled',
    'volume-low',
    'volume-off-filled',
    'volume-off',
    'warning-filled',
    'warning',
    'wrench-filled',
    'wrench',
]);
